import { CaseInsensitiveSearchParams } from '../utils/CaseInsensitiveSearchParams.mjs';

export const SPEC_MODE = {
  PUBLIC: 'public',
  INTERNAL: 'internal',
  SPA: 'spa',
};

export const SPEC_OPTIONS = [
  {
    value: SPEC_MODE.PUBLIC,
    label: 'Lego Unified API',
  },
  {
    value: SPEC_MODE.INTERNAL,
    label: 'Lego Unified API (Internal)',
  },
  {
    value: SPEC_MODE.SPA,
    label: 'Portal API Server',
  },
];

export function getInitialSpecMode() {
  const urlParams = new CaseInsensitiveSearchParams(window.location.search);
  const specParam = urlParams.get('spec');

  if (specParam && SPEC_OPTIONS.some((item) => item.value === specParam)) {
    return specParam;
  }

  if (urlParams.get('internal') === '1') {
    return SPEC_MODE.INTERNAL;
  }

  return SPEC_MODE.PUBLIC;
}

export function syncSpecModeInUrl(specMode) {
  const currentUrl = new URL(window.location.href);
  const params = new CaseInsensitiveSearchParams(currentUrl.search);
  params.set('spec', specMode);

  if (specMode === SPEC_MODE.INTERNAL) {
    params.set('internal', '1');
  } else {
    params.delete('internal');
  }

  currentUrl.search = params.toString();
  window.history.replaceState({}, '', currentUrl.toString());
}
